<template>
  <p>
    ______________________________________ ______________________________________
    _______________________________________ _______________________________________
    ________________________________________ __________________________
  </p>
</template>
<script lang="ts" setup></script>
<style lang="less" scoped>
p {
  line-height: 1px !important;
  visibility: hidden;
}
</style>
